import React from 'react'
import styled from '@emotion/styled'
import get from 'lodash/get'
import { useStaticQuery, graphql } from 'gatsby'

import mq from '../styles/breakpoints'

import { Button } from '../components/Button'
import { IOneLink } from '../graphql/sections/oneLink'
import { IFooter } from '../graphql/sections/footer'
import { usePickLocalized } from '../context/LocaleContextProvider'

interface IProps {
  data: { stickyCTA: IOneLink }
}

const Section = styled.div`
  ${mq({
    display: ['block', 'none', 'none'],
    width: '100%',
    position: 'sticky',
    bottom: '-25px',
    paddingTop: '100px',
    textAlign: 'center',
  })}
`

const stickyCTAStyles = {
  display: 'inline-block',
  width: '100%',
  padding: '0 0 15px 0',
}

const stickyCTACustomStyles = {
  display: 'block',
  width: '100%',
  borderRadius: '0',
}

export const StickyCTA: React.FC<IProps> = React.memo(
  ({
    data: {
      stickyCTA: { oneLink },
    },
  }) => {
    const stickyCTALink = oneLink.link
    const stickyCTAText = oneLink.linkText
    const stickyCTAName = oneLink.linkName
    const stickyCTARel = oneLink.rel
    const contentfulId = oneLink.contentful_id
    const typeName = oneLink.__typename

    const isActive = false
    // experiments &&
    // experiments.some(experiment => {
    //   return experiment.config && experiment.config.stickyCTA === 'true'
    // })

    return isActive ? (
      <Section>
        <Button
          to={stickyCTALink}
          name={stickyCTAName}
          rel={stickyCTARel}
          style={stickyCTAStyles}
          styleOverrides={stickyCTACustomStyles}
          contentfulId={contentfulId}
          typeName={typeName}
        >
          {stickyCTAText}
        </Button>
      </Section>
    ) : null
  },
)

type StickyCTASectionProps = {
  // The page's custom footer, already in the page's locale. Null uses the default footer's sticky CTA.
  customFooter: IFooter | null
}

export const StickyCTASection: React.FC<StickyCTASectionProps> = ({ customFooter }) => {
  // Pinned to the site footer: preview also sources an empty, never-published footer draft (utNRi15nmaUETMXTCkYL2),
  // and an unpinned query returns whichever footer node loaded first.
  const data = useStaticQuery<{ contentfulFooter: IFooter; frenchFooter: IFooter | null }>(graphql`
    query {
      contentfulFooter(contentful_id: { eq: "SHB55PuzCknpmANS4q1hS" }, node_locale: { ne: "fr-CA" }) {
        ...FooterFragment
      }
      frenchFooter: contentfulFooter(contentful_id: { eq: "SHB55PuzCknpmANS4q1hS" }, node_locale: { eq: "fr-CA" }) {
        ...FooterFragment
      }
    }
  `)
  const defaultFooter = usePickLocalized({ 'en-CA': data.contentfulFooter, 'fr-CA': data.frenchFooter })
  const { stickyCTA } = customFooter ?? defaultFooter

  return stickyCTA ? <StickyCTA data={{ stickyCTA }} /> : null
}

export default StickyCTASection
